import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ViewUIPlus from 'view-ui-plus';
import 'view-ui-plus/dist/styles/viewuiplus.css';
import "./assets/style.css";

const app = createApp(App);
app.use(router);
app.use(store);
app.use(ViewUIPlus);

import initMenu from "./utils/menus.js";

// 初始化菜单 在路由加载前执行 to.path == '/' 判断要跳转的路由是否是根路径
router.beforeEach((to,from,next)=>{
  if(to.path == '/'){
    next();
  }else{
    if(store.state.menus != null){  // 如果已经初始化过菜单 
        next();
    }else{  // 没有初始化过菜单
      initMenu(router, store);  // 初始化菜单
      next();  // 放行
    }
  }
});

app.mount('#app');

// 在Vue应用中启用Vue DevTools
// Vue.config.devtools = true;